import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData, handleErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimalKeyAllowNegative } from "@/js/events/keycodes.js";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
var defaultServiceForm = {
  id: null,
  name: "",
  defaultUnitPriceExVatEuro: null,
  valid: false
};
export default {
  name: "OrderServicePresetSelect",
  components: {
    Confirm: Confirm
  },
  props: {
    presetServices: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      model: {
        id: null,
        name: null,
        defaultUnitPriceExVatEuro: null
      },
      savingService: {
        isPending: false,
        isConfiguring: false,
        cancellationToken: null,
        form: _objectSpread({}, defaultServiceForm)
      },
      removingService: {
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.savingService.isPending || this.removingService.isPending;
    },
    isAnySubformInProgress: function isAnySubformInProgress() {
      return this.savingService.isConfiguring;
    }
  },
  created: function created() {},
  methods: {
    cancel: function cancel() {
      this.$emit("cancelled");
    },
    confirm: function confirm() {
      this.$emit("confirmed", this.model);
    },
    startEditService: function startEditService(item) {
      this.savingService.isConfiguring = true;
      if (item) this.savingService.form = _objectSpread(_objectSpread({}, item), {}, {
        valid: true
      });
    },
    confirmEditService: function confirmEditService() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$savingService$;
        var _this2$savingService$2, valid, withoutValid, _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.savingService.isPending = true;
              (_this2$savingService$ = _this2.savingService.cancellationToken) === null || _this2$savingService$ === void 0 || _this2$savingService$.cancel();
              _this2.savingService.cancellationToken = axios.CancelToken.source();
              _this2$savingService$2 = _this2.savingService.form, valid = _this2$savingService$2.valid, withoutValid = _objectWithoutProperties(_this2$savingService$2, _excluded);
              _this = _this2;
              _context.next = 7;
              return request("/v1/standalone-orders/preset-services", "post", withoutValid, true, "api", null, _this.savingService.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.savingService.isPending = false;
                  _this.savingService.cancellationToken = null;
                  var errorData = getErrorData(e, {}, "Unable to save the service", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 7:
              response = _context.sent;
              if (response) {
                _this2.$emit("reloaded");
                _this2.model = {
                  id: +response.data.value,
                  name: withoutValid.name,
                  defaultUnitPriceExVatEuro: withoutValid.defaultUnitPriceExVatEuro,
                  display_name: "".concat(withoutValid.name).concat(withoutValid.defaultUnitPriceExVatEuro !== null ? " (".concat(formatPrice(withoutValid.defaultUnitPriceExVatEuro), " ").concat(getSymbolCurrency("EUR"), ")") : "")
                };
              }
              _this2.cancelEditService();
              _this2.savingService.isPending = false;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    cancelEditService: function cancelEditService() {
      this.savingService.isConfiguring = false;
      this.savingService.form = _objectSpread({}, defaultServiceForm);
    },
    removeService: function removeService(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var confirm, _this3$removingServic, _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.removingService.isPending = true;
              _context2.next = 3;
              return _this3.$refs.confirm.open("Remove service", "Are you sure you want to remove this service ?", {
                color: "red"
              });
            case 3:
              confirm = _context2.sent;
              if (!confirm) {
                _context2.next = 11;
                break;
              }
              (_this3$removingServic = _this3.removingService.cancellationToken) === null || _this3$removingServic === void 0 || _this3$removingServic.cancel();
              _this3.removingService.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 10;
              return request("/v1/standalone-orders/preset-services/".concat(item.id), "delete", null, true, "api", null, _this.removingService.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.removingService.isPending = false;
                  _this.removingService.cancellationToken = null;
                  var errorData = getErrorData(e, {}, "Unable to remove the service", true);
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 10:
              _this3.$emit("reloaded");
            case 11:
              _this3.removingService.isPending = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    filterDecimalKeyAllowNegative: filterDecimalKeyAllowNegative
  }
};